import React, { createContext, useContext } from 'react';
import { PriceService } from '../../services';
import { CurrencyCode } from '../../server-types';
import { useAuth } from './auth';

interface ContextProps {
    priceService: PriceService;
}

/*
    Hopefully there is a better way to do this.
    Otherwise TS was yelling
 */
const defaultState = {
    priceService: new PriceService(CurrencyCode.CZK, 'en-US'),
};

const PriceServiceContext = createContext<ContextProps>(defaultState);

export const PriceServiceProvider: React.FC = ({ children }) => {
    const priceService = useProvidePriceService();

    return <PriceServiceContext.Provider value={priceService}>{children}</PriceServiceContext.Provider>;
};

export const usePriceService = () => {
    return useContext(PriceServiceContext);
};

// Provider hook that creates auth object and handles state
function useProvidePriceService() {
    const { user } = useAuth();
    const currency = user ? user.defaultCurrency.currencyCode : CurrencyCode.CZK;

    const locale = user ? user.languageCode : navigator.language;

    const priceService = new PriceService(currency, locale);
    return {
        priceService,
    };
}
